<div class="business-statewise-stats w-full card-bg duration-200 rounded-lg p-6 relative">
  <!-- Header with Title and Selection -->
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-lg font-medium text-[#141437] dark:text-white uppercase">Business States</h2>
    
    <!-- Data Type Selection -->
    <div class="w-auto">
      <app-selection
        [mode]="'single'"
        [options]="dataTypeOptions"
        [name]="'dataTypeSelector'"
        [size]="'md'"
        [variant]="'default'"
        [orientation]="'horizontal'"
        [fullWidth]="false"
        [(ngModel)]="selectedValue"
        (valueChange)="onDataTypeChange($event)">
      </app-selection>
    </div>
  </div>

  <!-- Summary Stats -->
  <div class="flex items-center gap-6 mb-6">
    <div class="flex items-center gap-2">
      <span class="w-3 h-3 rounded-full bg-[#AD46FF]"></span>
      <span class="text-sm text-slate-700 dark:text-slate-300">Current: 
        <span class="font-semibold text-slate-800 dark:text-slate-100">{{ currentTotal }}</span>
      </span>
    </div>
    
    @if (previousTotal !== undefined || previousTotal !== null) {
      <div class="flex items-center gap-2">
        <span class="w-3 h-3 rounded-full bg-slate-400"></span>
        <span class="text-sm text-slate-700 dark:text-slate-300">Previous: 
          <span class="font-semibold text-slate-800 dark:text-slate-100">{{ previousTotal }}</span>
        </span>
      </div>
    }
  </div>

  <!-- Grid Layout: Table + Map -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <!-- Left: Table -->
    <div class="overflow-hidden h-[500px]">
      <app-scroll-table
        [tableData]="tableData"
        [previousData]="previousTableData"
        [headers]="tableHeaders"
        [showHeading]="false">
      </app-scroll-table>
    </div>

    <!-- Right: Map -->
    <div class="map-wrapper w-full h-[500px] bg-slate-50 dark:bg-slate-900/50 rounded-lg p-4">
      <app-nation-chart
        [stateData]="stateChartData"
        [valueKeys]="valueKeys">
      </app-nation-chart>
    </div>
  </div>
    @if(isLoading()){
        <app-individual-toaster></app-individual-toaster>
      }
</div>
